import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { sleep } from '@helpers/utils';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import FeaturedCard from './Card/Card';
import S from './DesktopNavigation.styles';
const DesktopNavigation = (props) => {
    const [fullyOpen, setFullyOpen] = React.useState(false);
    return (React.createElement(S.Container, { "aria-label": "main menu" }, props.links.map((link) => (React.createElement(React.Fragment, { key: link.id },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.TopLink, { id: `${link.id}-top-link`, ...(link.children.length > 0
                    ? { as: 'button', onClick: () => handleTopLinkClick(link) }
                    : { href: link.url, target: link.target }), "data-active": props.activeLink === link.id }, link.text)),
        link.children.length > 0 ? renderNavigationDropdown(link) : null)))));
    async function handleTopLinkClick(link) {
        if (link.id === props.activeLink) {
            props.setActiveLink('');
            props.setActiveSecond('');
            setFullyOpen(false);
        }
        else if (props.activeLink !== '') {
            props.setActiveLink('pending');
            props.setActiveSecond('');
            setFullyOpen(false);
            await sleep(900); // allow open dropdown to close before opening
            props.setActiveLink(link.id);
            await sleep(1100); // allow dropdown to fully open before showing scrollbars
            setFullyOpen(true);
        }
        else {
            props.setActiveSecond('');
            props.setActiveLink(link.id);
            await sleep(1100); // allow dropdown to fully open before showing scrollbars
            setFullyOpen(true);
        }
    }
    async function handleSecondLevelClick(id) {
        if (id === props.activeSecond) {
            props.setActiveSecond('');
            setFullyOpen(false);
        }
        else if (props.activeSecond !== '') {
            props.setActiveSecond('');
            setFullyOpen(false);
            await sleep(900); // allow open level to close before opening
            props.setActiveSecond(id);
            await sleep(1100); // allow dropdown to fully open before showing scrollbars
            setFullyOpen(true);
        }
        else {
            props.setActiveSecond(id);
            await sleep(1100); // allow dropdown to fully open before showing scrollbars
            setFullyOpen(true);
        }
    }
    function renderNavigationDropdown(link) {
        return (React.createElement(S.NavigationDropdown, { "aria-labelledby": `${link.id}-top-link` }, link.children.length > 1 ? (React.createElement(React.Fragment, null,
            React.createElement(S.SecondLevelContainer, { "data-active": props.activeLink === link.id },
                React.createElement(S.SecondLevelList, null,
                    React.createElement("li", null,
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.LevelTwoLink, { href: link.url, target: link.target, tabIndex: props.activeLink !== link.id ? -1 : undefined },
                                link.text,
                                " ",
                                getSvgFromSystem(SystemIcon.ArrowRight)))),
                    renderLevelTwoLinks(link.children, props.activeLink !== link.id ? -1 : undefined))),
            link.children.map((levelTwo) => (React.createElement(S.ThirdLevelContainer, { key: `${levelTwo.id}-child-links`, "data-active": props.activeSecond === levelTwo.id, "data-open": fullyOpen },
                React.createElement(S.ThirdLevelList, null,
                    React.createElement(S.ThirdLevelFirstLink, null,
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.LevelTwoLink, { href: levelTwo.url, target: levelTwo.target, tabIndex: props.activeSecond !== levelTwo.id ? -1 : undefined },
                                levelTwo.text,
                                " ",
                                getSvgFromSystem(SystemIcon.ArrowRight)))),
                    renderLevelThreeLinks(levelTwo.id, levelTwo.children, props.activeSecond !== levelTwo.id ? -1 : undefined)),
                levelTwo.featuredCard && (React.createElement(S.FeaturedCard, null,
                    React.createElement(FeaturedCard, { ...levelTwo.featuredCard, wide: false, tabIndex: props.activeSecond !== levelTwo.id ? -1 : undefined }))),
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.CloseButton, { "aria-label": `Close ${levelTwo.text} Links`, onClick: () => {
                            props.setActiveSecond('');
                            setFullyOpen(false);
                        }, tabIndex: props.activeSecond !== levelTwo.id ? -1 : undefined }, getSvgFromSystem(SystemIcon.Cross)))))))) : (React.createElement(React.Fragment, null,
            React.createElement(S.SecondLevelContainer, { "data-active": props.activeLink === link.id, tabIndex: props.activeLink !== link.id ? -1 : undefined, "data-third-only": true }),
            React.createElement(S.ThirdLevelContainer, { "data-third-only": true, "data-active": props.activeLink === link.id, "data-open": fullyOpen },
                React.createElement(S.ThirdLevelList, null,
                    React.createElement(S.ThirdLevelFirstLink, null,
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.LevelTwoLink, { href: link.url, target: link.target, tabIndex: props.activeLink !== link.id ? -1 : undefined },
                                link.text,
                                " ",
                                getSvgFromSystem(SystemIcon.ArrowRight)))),
                    renderLevelThreeLinks(link.id, link.children[0].children, props.activeLink !== link.id ? -1 : undefined)),
                link.children[0].featuredCard && (React.createElement(S.FeaturedCard, null,
                    React.createElement(FeaturedCard, { ...link.children[0].featuredCard, wide: true, tabIndex: props.activeLink !== link.id ? -1 : undefined }))),
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.CloseButton, { "aria-label": `Close ${link.text} Links`, onClick: () => {
                            props.setActiveLink('');
                            setFullyOpen(false);
                        }, tabIndex: props.activeLink !== link.id ? -1 : undefined }, getSvgFromSystem(SystemIcon.Cross))))))));
    }
    function renderLevelTwoLinks(links, tabIndex) {
        return (React.createElement(React.Fragment, null, links.map((link) => (React.createElement("li", { key: link.id },
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.LevelTwoLink, { ...(link.children.one.length > 0
                        ? { as: 'button', onClick: () => handleSecondLevelClick(link.id), tabIndex }
                        : { href: link.url, target: link.target, tabIndex }) },
                    link.text,
                    " ",
                    getSvgFromSystem(SystemIcon.ArrowRight))))))));
    }
    function renderLevelThreeLinks(id, cols, tabIndex) {
        return (React.createElement(React.Fragment, null,
            React.createElement(S.LinkColumn, null, cols.one.map((group, index) => (React.createElement(S.LinkGroup, { key: `${id}-0${index}-level-three-col-1` }, group.map((link) => (React.createElement("li", { key: link.id },
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.LevelThreeLink, { ...(link.url && link.url !== '' && link.url !== null
                            ? { href: link.url, target: link.target, tabIndex }
                            : { as: 'span' }) }, link.text))))))))),
            cols.two.length ? (React.createElement(S.LinkColumn, null, cols.two.map((group, index) => (React.createElement(S.LinkGroup, { key: `${id}-0${index}-level-three-col-2` }, group.map((link) => (React.createElement("li", { key: link.id },
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.LevelThreeLink, { ...(link.url && link.url !== '' && link.url !== null
                            ? { href: link.url, target: link.target, tabIndex }
                            : { as: 'span' }) }, link.text)))))))))) : null));
    }
};
export default DesktopNavigation;
